/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-17 10:33:30
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { Button, Icon } from '@shopify/polaris';
import { LockMinor, MobileCancelMajor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import { getShop } from 'src/helpers';

import type { ComposedProps, State } from './index.type';

class BannerUpgrade extends Component<ComposedProps, State> {
  state = {
    dismissedBanner: false
  };
  componentDidMount() {
    // Hide banner
    this.checkDismissedBanner();
  }

  render() {
    const { dismissedBanner } = this.state;
    const { i18n, actionLabel, days, subscribedBefore, disableLockUnLock } = this.props;

    return !dismissedBanner ? (
      <div className="premium-warning-restore background-addon-unlock">
        <Icon source={LockMinor} color="base" />
        <div style={{ width: '95%' }}>
          <p style={{ marginBottom: '10px' }}>
            {i18n.translate(
              `AdminHTML.Analytics.AnalyticsV2.${
                subscribedBefore ? 'unlockAddonReclaimContent' : 'unlockAddonContent'
              }`,
              {
                days: <strong>{days}</strong>
              }
            )}
          </p>
          <div
            onClick={this.handleUnlock}
            className={`unlock-button Polaris-Button ${
              disableLockUnLock ? 'unlock-button-disabled' : ''
            }`}>
            {subscribedBefore
              ? i18n.translate('AdminHTML.Analytics.AnalyticsV2.unlockAddonReclaimAction')
              : i18n.translate(`AdminHTML.Common.Action.${actionLabel}`)}
          </div>
        </div>
        <Button onClick={this.onDismiss} icon={MobileCancelMajor} plain />
      </div>
    ) : (
      ''
    );
  }

  handleUnlock = () => {
    const { handleUnlock, disableLockUnLock } = this.props;
    if (disableLockUnLock) return;
    handleUnlock();
  };
  // Get dismissed banner status
  checkDismissedBanner = () => {
    const shop = getShop();
    let dismissed = false;
    try {
      dismissed = localStorage.getItem(`${shop}-dismissBannerRestoreAddonAnalytics`);
    } catch (error) {}

    if (dismissed === 'true') {
      this.setState({ dismissedBanner: true });
    }
  };
  // Handle hide banner
  onDismiss = () => {
    const shop = getShop();
    try {
      localStorage.setItem(`${shop}-dismissBannerRestoreAddonAnalytics`, `true`);
    } catch (error) {}

    // Hide banner
    this.setState({ dismissedBanner: true });
  };
}

export default withI18n()(BannerUpgrade);
